import QuestionnairePage from "./QuestionnairePage";

// Re-export current questionnaire UI for onboarding routing.
export default function OnboardingQuestionnairePage() {
  return <QuestionnairePage />;
}

